export default __webpack_public_path__ + "static/14_36-6e2190e4c9b385bb50390a88cf7d55a5.png";